import { Component, OnInit, Inject } from '@angular/core';
import { AnwService } from 'src/app/Services/ANW/anw.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Course, Season, FirestoreReference } from 'src/app/Classes/schema';

@Component({
  selector: 'app-new-course',
  templateUrl: './new-course.component.html',
  styleUrls: ['./new-course.component.css']
})
export class NewCourseComponent implements OnInit {
  course: Course;
  airdate: string;
  constructor(
    private anw: AnwService,
    private dialogRef: MatDialogRef<NewCourseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { season: FirestoreReference<Season> }
  ) {
    this.course = new Course();
    console.log(this.data.season);
  }

  ngOnInit() {
    console.log(this.data);
    this.course.seasonName = this.data.season.data.season;
    this.course.seasonId = this.data.season.id;
  }

  saveCourse() {
    console.log(this.course);
    console.log(this.airdate);
    this.course.airDate = new Date(this.airdate);
    this.anw.fhs.writeDoc("courses", this.course, this.course.id());
    this.dialogRef.close();
  }
}
